import DraftsFilterModal from '../ui/DraftsFilterModal.vue';
import {
  buildDraftsListUrlQuery,
  countActiveDraftFilters,
  parseDraftsListFilters,
  parseDraftsListSort,
  toDraftsListSort,
} from '../lib/drafts-list-query';
import type { DraftsListFilters, DraftsListSort } from '../lib/drafts-list-query';
import type { ListMatricesParams } from '../api/matrices.api';
import { useListControls } from './useListControls';
import type { ListControlsOptions } from './useListControls';

type DraftListRequestParams = Pick<
  ListMatricesParams,
  'sort' | 'order' | 'updatedAt' | 'createdBy'
>;

export function useDraftListControls(options: ListControlsOptions) {
  return useListControls<DraftsListSort, DraftsListFilters, DraftListRequestParams>(
    {
      filterModal: DraftsFilterModal,
      parseSort: parseDraftsListSort,
      parseFilters: parseDraftsListFilters,
      toSort: toDraftsListSort,
      pickFilters: ({ updatedAt, createdBy }) => ({ updatedAt, createdBy }),
      countFilters: countActiveDraftFilters,
      buildUrlQuery: buildDraftsListUrlQuery,
      toRequestParams: (sortState, filters) => ({
        sort: sortState.sort || undefined,
        order: sortState.order || undefined,
        updatedAt: filters.updatedAt,
        createdBy: filters.createdBy,
      }),
    },
    options
  );
}
